import { createContext, useContext } from "react";
import { ClientData } from "src/types/ClientDetails";

export const ClientSetUpContext = createContext<
  | {
      clientData: ClientData;
      setClientData: React.Dispatch<React.SetStateAction<ClientData>>;
    }
  | undefined
>(undefined);

export const useClientDataContext = () => {
  const clientData = useContext(ClientSetUpContext);
  if (!clientData) {
    throw new Error("useClientContex must be used with a ClientSetUpContext");
  }
  return clientData;
};

export const TestDataContext = createContext<
  | {
      initialTestData: Map<string, Map<string, Map<string, any>>>;
      setInitialTestData: React.Dispatch<
        React.SetStateAction<Map<string, Map<string, Map<string, any>>>>
      >;
    }
  | undefined
>(undefined);

export const useTestDataContext = () => {
  const initialTestData = useContext(TestDataContext);
  if (!initialTestData) {
    throw new Error("useClientContex must be used with a ClientSetUpContext");
  }
  return initialTestData;
};
